<template>
  <div class="cont">
    <!-- <div>
      <van-nav-bar
      title="隐私政策"
      style="background:linear-gradient(to right,#19CBDA,#2EDD9C);color:#fff;position: fixed;top:0;width:100%"
      >
        <template #left>
          <van-icon name="arrow-left" @click="onClickLeft" color="#fff" size="18" />
        </template>
      </van-nav-bar>
    </div> -->
    <div class="content-warp">
      <div class="content">
        <h2 class="title">{{ys.ystit}}</h2>
        <p class="tit text-20">{{ys.ystit2}}</p>
        <span class="text text-20">{{ys.text}}</span>
        <h2 class="text">{{ys.text1}}</h2>
        <h2 class="text">
          <p style="font-weight:bold;color:#222;">{{ys.text2}}</p>
        </h2>
        <h2 class="title">{{sy.tit}}</h2>
        <ul>
          <li v-for="(item,i) in sy.text" :key="i+'a'" v-html="item">{{item}}</li>
        </ul>
      </div>
      <div class="content">
        <h1 class="title">一. 我们如何搜集和使用您的信息？</h1>
        <div style="width:100%" v-for="(items,index) in ys1" :key="index+'b'">
          <h2 class="tit">{{items.tit}}</h2>
          <ul>
            <li v-for="(item,i) in items.text" :key="i+'c'" v-html="item">{{item}}</li>
          </ul>
        </div>
      </div>
      <div class="content">
        <div v-for="(items,index) in ys_1_2" :key="index+'d'">
          <h2 class="tit">{{items.tit}}</h2>
          <ul>
            <li class="text-20" v-for="(item,i) in items.text" :key="i+'e'" v-html="item">{{item}}</li>
          </ul>
        </div>
        <div v-for="(items,index) in ys_1_2_4" :key="index+'f'">
          <h2 class="tit">{{items.tit}}</h2>
          <span class="text">{{items.text}}</span>
        </div>
        <div v-for="(items,index) in ys_1_2_11" :key="index+'g'">
          <h2 class="tit">{{items.tit}}</h2>
          <ul>
            <li class="text-20" v-for="(item,i) in items.text" :key="i+'h'" v-html="item">{{item}}</li>
          </ul>
        </div>
        <div>
          <h2 class="tit">{{ys_2.tit}}</h2>
          <ul>
            <li v-for="(item,index) in ys_2.text" :key="index+'h'">
              {{item}}
            </li>
          </ul>
        </div>
        <div v-for="(items,j) in ys_3" :key="j+'k'">
          <h2 class="tit">{{items.tit}}</h2>
          <ul>
            <li class="" v-for="(item,i) in items.text" :key="i+'g'" v-html="item">{{item}}</li>
          </ul>
        </div>

        <div>
          <h2 class="tit">{{ys_7.tit}}</h2>
          <span class="text text-20">{{ys_7.tit1}}</span>
          <ul>
            <li v-for="(item,index) in ys_7.text" :key="index+'f'">
              <span>{{item.tit}}</span>
              <span>{{item.text}}</span>
            </li>
          </ul>
        </div>

        <div>
          <h2 class="tit">{{ys_8.tit}}</h2>
          <span class="text">{{ys_8.text}}</span>
        </div>
        <div>
          <h2 class="tit">{{ ys_9.tit }}</h2>
          <span class="text text-20">{{ ys_9.tit1 }}</span>
          <ul>
            <li v-for="(item, index) in ys_9.text" :key="index + 'f'">
              <span>{{ item.tit }}</span>
              <span>{{ item.text }}</span>
            </li>
          </ul>
        </div>
        <div v-for="(ite,i) in ysT" :key="i+1">
          <h2 class="title">{{ite.tit}}</h2>
          <ul>
            <li v-for="(it,index) in ite.text"
            :key="index+'h'"
             v-html="it">
             <li v-if="ite.tit === '五. 第三方服务提供商'">
              <router-link to="/sdkList">《浪加APP接入第三方SDK共享清单》</router-link>
            </li>
            <!--  {{it}} -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'policy',
    data() {
      return {
        ys: {
          ystit: '隐私政策',
          ystit2: '引言',
          text: '青岛英派斯健康科技股份有限公司（以下简称「浪加」或「我们」）非常重视您的个人信息，并让您对个人信息拥有控制权，我们会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问 浪加 时，或使用我们提供的服务前，您需要同意本政策中关于我们如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问我们的产品和服务。',
          text1: '本隐私权政策旨在协助您了解我们会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息。',
          text2: '注意：进入或使用本App意味着您同意我们的隐私声明。若您不同意这些条款，请不要进入或使用本App。',

        },
        sy: {
          tit: '术语',
          text: [
            '<strong style="color:#222;">1. Cookie：</strong>Cookie 是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie 使该网站可以识别您的浏览器。Cookie 还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的Cookie ，或者在发送 Cookie 时提示。但如果没有 Cookie ，某些网站功能或服务可能无法正常工作。',
            '<strong style="color:#222;">2. 应用数据缓存：</strong>应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。',
            '<strong style="color:#222;">3. 个人信息：</strong>用户向我们提供的、可用于识别用户的个人身份的信息，例如姓名、电子邮件地址、电话号码、银行卡号、身份证号码、住址、通讯记录等信息，或我们可以正当地通过链接找到此类信息的其他数据。',
            '<strong style="color:#222;">4. IP地址：</strong>每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP) 地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP 地址通常可用于识别计算机连接至互联网时所在的国家/地区。',
            '5.「未成年人」的定义为未满18周岁的未成年人，同时还应考虑适用的法律以及各国家和地区的文化惯例。'
          ]
        },
        ys1: [{
            tit: '1. 我们如何搜集您的信息？',
            text: [
              '我们提供服务时，可能会收集、储存和使用下列信息：'
            ]
          },
          {
            tit: '1.1 您提供的信息',
            text: [
              '1.1.1 您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如您的姓名、身高、体重、电话号码、地址等信息。如果您想充分使用我们提供的各种功能，可能还需要创建公开显示的个人资料，其中可能会包含您的姓名和照片。',
              '1.1.2 您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时上传、提交、存储、发送或接收的信息。'
            ]
          },
          {
            tit: '1.2 您在使用服务过程中，我们获取的信息',
            text: [
              '我们会收集您使用的服务以及使用方式的信息，如您使用 浪加App 运动、 使用 浪加 硬件产品或服务时可能产生的相关信息。此类信息包括：',
              '1.2.1 设备信息：我们会根据您在软件安装及/或使用授权的具体权限，接收并记录您所使用的设备相关信息，设备信息包含(Android ID、IMEI、MEID、IMSI、Serial、ICCID、BSSID、SSID、IDFA、IDFV、OpenUDID、GUID、OAID、SIM信息)，再例如您的设备型号、操作系统版本信息、设备设置、移动设备版本、设备识别码、MAC、手机号、屏幕分表率、GPS、设备是否root、设备环境等软硬件特征信息、设备所在位置相关信息，例如IP地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站等传感器信息。如果您在安装及/或使用过程中拒绝授予我们相应权限的，我们并不会记录您上述对应的信息。'
            ]
          }
        ],
        ys_1_2: [{
            tit: '1.2.2 日志信息',
            text: [
              'A. 设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；',
              'B. 在使用我们服务时浏览或要求提供的信息和内容详情；'
            ]
          },
          {
            tit: '1.2.3 IP地址',
            text: [
              'A. 有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；',
              'B. 您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；',
              'C. 您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。'
            ]
          }
        ],
        ys_1_2_4: [{
            tit: '1.2.4 设备中的视频、图片软件等',
            text: '为了给您提供全方位的运动体验，经过您的授权，我们的服务器会提取您设备中的视频、图片、软件名、版本号等，并通过加密上传到服务器进行比对，用于匹配与该视频、图片、软件相对应的显示功能。同时，您也可以随时通过相关功能设置拒绝/取消该权限。拒绝提供该权限仅会使您无法使用上述功能，但不影响 浪加 其他功能与服务的正常使用；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的信息，否则您的取消行为不会影响我们基于您之前的授权进行的信息的处理、存储。'
          },
          {
            tit: '1.2.5 扫描二维码、拍摄照片',
            text: '当您使用扫描二维码、拍摄照片、拍摄视频功能时，我们将访问您的设备相机相关权限，并收集您提供的基于扫描二维码、拍摄照片后向我们上传的图片、视频信息。如您拒绝提供权限和内容的，仅会使您无法使用该功能，但并不影响您正常使用 浪加 的其他功能。同时，您也可以随时通过相关功能设置取消该权限。当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的信息，否则您的取消行为不会影响我们基于您之前的授权进行的信息的处理、存储。'
          },
          {
            tit: '1.2.6 蓝牙',
            text: '若您已有相关硬件设备，希望将硬件产品记录的信息同步至 浪加, 则可以通过开启蓝牙功能实现。如您拒绝开启的，仅会使您无法使用该功能，但并不影响您正常使用 浪加 的其他功能。同时，您也可以随时通过相关功能设置取消该权限。但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的信息，否则您的取消行为不会影响我们基于您之前的授权进行的信息的处理、存储。'
          },
          {
            tit: '1.2.7 位置信息',
            text: '您可以授权开启设备定位功能并使用我们基于位置提供的相关服务，当然，您也可以通过关闭定位功能随时停止我们对您的地理位置信息的收集。同时，您也可以随时通过相关功能设置取消该权限。当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的信息，否则您的取消行为不会影响我们基于您之前的授权进行的信息的处理、存储。'
          },
          {
            tit: '1.2.8 通讯录',
            text: '如您想跟踪了解自己朋友们使用 浪加 的情况，可以申请使用 浪加 相关功能，我们将根据您的授权上传和查询用户通讯录中联系人手机号码。同时，您也可以随时通过相关功能设置拒绝/取消该权限。拒绝提供该权限仅会使您无法使用上述功能，但不影响 浪加 其他功能与服务的正常使用；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的信息，否则您的取消行为不会影响我们基于您之前的授权进行的信息的处理、存储。'
          },
          {
            tit: '1.2.9 麦克风和录音',
            text: '当您使用录制视频功能时我们将访问您的设备麦克风和录音相关权限，我们需要收集您的语音信息、语音交互信息。如您拒绝提供的，仅会使您无法使用该功能，但并不影响您正常使用 浪加 的其他功能。同时，您也可以随时通过相关功能设置取消该权限。但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的信息，否则您的取消行为不会影响我们基于您之前的授权进行的信息的处理、存储。'
          },
          {
            tit: '1.2.10 软件安装列表',
            text: '当您使用发现-商城功能时，您可以选择直接打开天猫商城或者京东商城购买产品，或者在商城内浏览产品后再购买。我们需要获取软件安装列表以便判断您的手机是否已安装需要打开的应用。'
          },
        ],
        ys_1_2_11: [{
          tit: '1.2.11 设备信息与日志信息',
          text: [
            'A. 为了保障软件服务的安全运行、运营的质量及效率，我们会收集您的硬件型号、操作系统版本号、设备信息(Android ID、IMEI、MEID、IMSI、Serial、ICCID、BSSID、SSID、IDFA、IDFV、OpenUDID、GUID、OAID、SIM信息)、不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、网络设备硬件地址( MAC 地址）、唯一设备识别码、设备序列号、传感器信息、设备是否root、GPS、IP 地址、蓝牙( Bluetooth )、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备传感器数据（如加速度传感器）。',
            'B. 为了预防恶意程序、保障运营质量及效率、我们会收集安装的应用信息或正在运行的进程信息、软件列表或运行中的进程信息、软件列表或运行中的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。',
            'C. 分析产品使用情况：为分析我们产品的使用和表现情况，提升用户使用的体验，我们的合作方可能需要使用该产品来源与使用情况（崩溃、闪退、使用时长等）、设备标识信息、应用总体安装使用情况等信息。'
          ]
        }],


        ys_2: {
          tit: '我们可能将上述收集的信息用作以下用途：',
          text: [
            '2.1 向您提供服务；',
            '2.2 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；',
            '2.3 帮助我们设计新服务，改善我们现有服务；',
            '2.4 执行软件验证、升级服务；',
            '2.5 应用户特殊要求而提供特定服务时，需要将信息提供给我们的关联公司、第三方或其他用户；',
            '2.6 其他有利于用户和 浪加 运营者利益且不违反任何强制性法律法规的情况。'
          ]
        },
        ys_3: [{
            tit: '3. 我们承诺',
            text: [
              '3.1 我们不会与广告主分享可用于识别您个人身份的信息，例如您的姓名或电子邮件地址（除非经您授权同意）',
              '3.2 在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。'
            ]
          },
          {
            tit: '4. 经您授权同意后，我们将向关联公司或合作单位分享该产品、服务所必须的个人信息。我们会要求关联公司及合作单位按照我们的说明、隐私政策以及任何其他适当的保密和安全措施来保证您的个人信息安全。除此之外，未经您的授权同意，我们不会向任何第三方提供或分享您的信息。',
            text: ['']
          },
          {
            tit: '5. 我们不会将您的个人信息转移或披露给任何非关联的第三方，除非：',
            text: [
              '5.1 相关法律法规、法律程序、政府机关的强制性要求；',
              '5.2 为完成合并、分立、收购或资产转让而转移；',
              '5.3 事先获得您的授权；',
              '5.4 您使用共享功能；',
              '5.5 以学术研究或公共利益为目的；',
              '5.6 我们认为必要且不违反法律强制性规定的其他情形。'
            ]
          },
          {
            tit: '6. 除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。',
            text: ['']
          }
        ],
        ys_7: {
          tit: '7. 对 Cookie 和同类型技术的使用',
          tit1: 'Cookie 和同类型技术是互联网中的通用常用技术。当您使用 浪加 相关服务时，我们可能会使用相关技术向您的设备发送一个或多个 Cookie 或匿名标识符，以收集和存储您访问、使用 浪加 时的信息。我们使用 Cookie 和同类技术主要为了实现以下功能或服务：',
          text: [{
              tit: '7.1 保障产品与服务的安全、高效运转',
              text: '我们可能会设置认证与保障安全性的 Cookie 或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈等不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。'
            },
            {
              tit: '7.2 帮助您获得更轻松的访问体验',
              text: '使用此类技术可以帮助您省去重复填写个人信息、输入搜索内容的步骤和流程，例如实现一键登录流程、记录搜索历史。'
            }
          ]
        },
        ys_8: {
          tit: '8. 注销帐号',
          text: '您可以通过手动的方式申请注销账户，您可以按照【我的】-【设置】-【帐号与安全】-【注销帐号】的申请流程进行操作。我们将会在收到您的申请后及时进行处理，并在15个工作日或法律法规要求的时限内回复您的请求。您知悉并理解，注销帐号是不可逆的行为。当您注销帐号后,我们将删除有关您的相关信息或进行匿名化处理,但法律法规另有规定的除外。',
        }, ys_9: {
        tit: "9.管理您的个人信息",
        tit1:
          "我们非常重视您对个人信息的管理，并尽全力保护对您个人信息的查阅、复制、更正、补充、删除、撤回同意授权、注销账号、投诉举报的相关权利，以使您有能力保障您的隐私和信息安全。为了优化您的使用体验，我们也可能对操作设置进行调整，故如下指引仅供参考。",
        text: [
          {
            tit: "9.1 改变或撤回授权权限设置",
            text:
              "您可以在设备本身的操作系统中，关闭摄像头（相机）、相册（存储）、附近设备、位置权限、实时活动权限，改变同意范围或撤回您的授权。关闭授权后我们将不再收集与这些权限相关的信息。",
          },
          {
            tit: "9.2  改变或撤回账号绑定",
            text:
              "您可以通过手动的方式，解除与第三方账号的绑定关系，您可以按照【我的】-【设置】-【帐号与安全】-【绑定微信】的申请流程进行操作，具体以第三方平台所设置功能为准。",
          },
          {
            tit: "9.3  改变或撤回授权的信息处理",
            text:
              "因为我们产品是工具类APP，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的功能和服务，APP也不能继续使用了。撤回授权操作流程：【我的】-【设置】-【隐私设置】。",
          },
        ],
      },
        ysT: [{
            tit: '二. 如何更新、变更、导出、删除您的信息',
            text: [
              '1. 您在使用我们的产品和服务时，会被要求提供您真实的个人信息，您应当对您所提供信息的真实性、合法性、有效性及完整性负责，并及时更新和维护您的个人信息，以保证信息的真实、合法和有效。您可以随时管理您的个人信息，例如您的个人账户注册信息。',
              '2. 您可以自行从 浪加 账号中删除您的内容或个人信息，或要求我们删除或修改信息，例如您想要删除个人帐户，可以与我们联络并提出您的要求。',
              '3. 在有些情况下，我们会出于法律目的或合法业务的需要将数据保留有限的一段时间。我们会尽力确保 浪加 的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，我们可能会过一段时间才会从我们现用的和备用的系统中删除其副本。'
            ]
          },
          {
            tit: '三. 我们如何保护您的个人信息',
            text: [
              '1. 我们制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失。',
              '2. 尽管已经采取了合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您确认知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。',
              '3. 我们会制定应急处理预案，并在发生用户信息安全事件时立即应急预案，努力阻止该等安全事件的影响和后果扩大。在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。'
            ]
          },
          {
            tit: '四. 我们如何处理未成年人提供的个人信息',
            text: [
              '1. 我们非常重视未成年人信息的保护。在电子商务活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或监护人监护、指导下共同仔细阅读本隐私政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。',
              '2. 对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。',
              '3. 若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策第十条中公示的联系方式与我们联系。'
            ]
          },
          {
            tit: '五. 第三方服务提供商',
            text: [
              '1. 为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但我们对于第三方提供的产品或服务没有控制权。我们无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。',
              '2. 参加营销推广活动。当您选择参加我们举办的有关营销活动时，根据活动需要您需要提供姓名、通信地址、联系方式、银行账号等信息，以便第三方能及时向您提供奖品。当您选择参加我们举办的有关营销活动时，根据活动需要您需要提供姓名、通信地址、联系方式、银行账号等信息。经过您的明示同意，我们会将上述信息与第三方共享，以便我们能委托第三方及时向您提供奖品。',
              '3. 本应用中某些功能的技术模块由第三方SDK协助提供，有关客户端中接入的第三方SDK收集和使用用户信息的具体情况如下:',
              ]
            //   '微信SDK要完成微信授权登录，需要获取设备信息（应用安装列表，AndroidID和Mac地址）,腾讯隐私政策链接：https://privacy.qq.com',
            //   'Mob SD要完成第三方登录、分享，需要获取设备信息（AndroidID和Mac地址）,MobTech隐私政策链接：https://www.mob.com/about/policy',
            //   '极光 SDK要完成消息推送，需要获取设备信息（AndroidID和Mac地址）,极光隐私政策链接：https://www.jiguang.cn/license/privacy',
            //   '腾讯Bugly要完成应用异常信息收集，需要获取设备信息（AndroidID和Mac地址）,腾讯隐私政策链接：http://www.camera360.com/privacy_zh.html'
            // ]
          },
          {
            tit: '六.本政策的更新',
            text: [
              '1. 我们可能会不定期修改、更新本隐私政策，有关隐私政策的更新，我们会在 浪加 中以通知公告等形式发布，您可以访问 浪加 查询最新版本的隐私政策。对于重大变更，我们会向您发出郑重通知（包括对于某些服务，我们会通过电子邮件发送通知，说明对隐私政策进行的更改）。'
            ]
          },
          {
            tit: '七. 适用范围',
            text: [
              '1. 我们的隐私政策适用于 浪加 上提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。',
              '2. 我们的隐私权政策不适用于第三方提供的产品和服务，例如在 浪加 App上由第三方提供的产品和服务，以及在我们的服务中链接到的其他网站，这些产品、服务或网站会有独立的隐私政策予以规范，请另行查阅相应的政策规定。',
              '3. 对于为我们的服务进行广告宣传，以及可能使用我们的 Cookie 或其他日志信息来投放和使用广告的其他公司和组织，我们的隐私权政策并未涵盖其信息处理政策。'
            ]
          },
          {
          tit: "八. 联系我们",
          text: [
            "浪加由青岛英派斯健康科技股份有限公司提供，如果您对个人信息保护问题有投诉、举报、建议、疑问，您可以选择通过以下方式联系我们：",
            "  -您可以将问题发送至（langjiafeedback@impulsefitness.com）；",
            "  -您也可以致电400-618-0099与我们联系；",
            "我们核查并验证您的用户身份后会在五个工作日内响应，并在十五个工作日内反馈您的投诉与举报结果。",
            ]
          }
        ],
      }
    },
    methods: {}
  }
</script>
<style>
.content table {
  border: 1px solid #ccc;
  border-collapse: collapse;
}
.content table td {
  border: 1px solid #ccc;
  word-break: break-all;
  padding: 5px;
}
</style>

<style scoped>
  .cont {
    /* background:#fff */
  }

  .content-warp {
    border-radius: 10px;
    width: 95%;
    margin: 0 auto;
    padding: 10px 9px;
    background: #fff;
    margin-bottom: 10px;
    margin-top: 10px
  }

  .content {

    color: #999;
    width: 97%;
    margin: 0 auto;
  }
  table {
    border: 1px solid #ccc;
  }

  .title {
    font-weight: bold;
    color: #23d3bd;
    font-size: 16px;
    width: 100%;
  }

  .tit {
    font-size: 14px;
    color: #23d3bd;
    font-weight: bold;
    line-height: 20px;
    width: 100%;
  }

  .text {
    display: block;
    font-size: 14px;
  }

  ul,
  li {
    list-style: none;
    font-size: 14px;
    ;
  }

  .text-20 {
    text-indent: 20px;
  }

  h1 {
    font-size: 16px;
    color: #222;
    font-weight: bold;
    width: 100%
  }

  li strong {
    color: #222;
  }
</style>
